import { ChangeDetectionStrategy, Component, ViewEncapsulation, Input, OnInit } from '@angular/core';
import { ILoginReminder } from '@fi-app/other-settings/fi-login-reminder/fi-login-reminder';
import { FiLoginReminderService } from '@fi-app/other-settings/fi-login-reminder/fi-login-reminder.service';
import { FiLoginReminderTimePeriodTypes } from '@fi-app/other-settings/fi-login-reminder/fi-login-reminder-consts';
import { AppTextService } from '@fi-shared/app-text';
import { FiSnackBarService } from '@fi-shared/fi-snackbar/snack-bar.service';

@Component({
    selector: 'fi-login-reminder-edit',
    templateUrl: './fi-login-reminder-edit.component.html',
    styleUrl: './fi-login-reminder-edit.component.scss',
    changeDetection: ChangeDetectionStrategy.OnPush,
    encapsulation: ViewEncapsulation.None,
    host: { class: 'fi-login-reminder-edit' },
    standalone: false,
})
export class FiLoginReminderEditComponent implements OnInit {
    @Input() loginReminder: ILoginReminder;
    protected previewContact: string = '';

    constructor(
        private fiLoginReminderService: FiLoginReminderService,
        private appTextService: AppTextService,
        private fiSnackBarService: FiSnackBarService,
    ) {}

    ngOnInit(): void {
        this.updateDefaultMessage();
    }

    private updateDefaultMessage() {
        if (this.loginReminder.IsDefaultMessage) {
            this.loginReminder.Message = this.appTextService.get('login.default_message_text');
        }
    }

    protected save() {
        this.fiLoginReminderService.saveLoginReminder(this.loginReminder);
    }

    protected onSendPreviewClick() {
        this.fiLoginReminderService
            .sendLoginReminderPreview(this.previewContact, this.loginReminder.Message)
            .then(() => {
                this.fiSnackBarService.showSnackbar({
                    textMessage: this.appTextService.get('login.reminder_preview_sent'),
                    buttonText: this.appTextService.get('common.dismiss'),
                    iconClass: 'fa-solid fa-circle-info',
                });
            });
    }

    protected readonly FiLoginReminderTimePeriodTypes = FiLoginReminderTimePeriodTypes;
}
